// Locale-aware uppercase that bypasses CSS text-transform.
// Safari's `text-transform: uppercase` honors the system locale even when
// `<html lang>` and `-webkit-locale` say otherwise — leading to Turkish
// İ/ı for English text. Doing the casing in JS with an explicit BCP-47
// locale gives us deterministic, correct output.

import { useLang } from "@/context/lang";

const LOCALE_MAP: Record<string, string> = {
  en: "en-US",
  tr: "tr-TR",
  es: "es-ES",
  bs: "bs-BA",
  ru: "ru-RU",
  de: "de-DE",
};

export function useUpper() {
  const { lang } = useLang();
  const locale = LOCALE_MAP[lang] || "en-US";
  return (s: string) => s.toLocaleUpperCase(locale);
}
